module.exports = __webpack_public_path__ + "img/DPI.d75e8f65.svg";